<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right"></td>
        <td>
          <mat-checkbox [(ngModel)]="actionnaire.actionnaire_Exclu"
            >Actionnaire exclu pour le versement des dividendes</mat-checkbox
          >
        </td>
      </tr>
      <tr>
        <td class="text-right">Acompte</td>
        <td class="flex items-center gap-1">
          <mat-checkbox
            [(ngModel)]="actionnaire.actionnaire_PFL"
          ></mat-checkbox>
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Taux</mat-label>
            <input
              matInput
              type="number"
              inputnumber="DECIMAL"
              [(ngModel)]="actionnaire.actionnaire_PFLTaux"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Actions</td>
        <td class="flex items-center gap-1">
          <div class="relative flex-1 flex items-center input-prefix">
            <div class="input-prefix-label important-title dark-txt">PP</div>
            <mat-form-field appearance="outline" class="flex-1">
              <input
                matInput
                type="number"
                inputnumber="ENTIER"
                [(ngModel)]="actionnaire.actionnaire_PP"
                disabled="true"
              />
            </mat-form-field>
          </div>

          <div class="relative flex-1 flex items-center input-prefix">
            <div class="input-prefix-label important-title dark-txt">NP</div>
            <mat-form-field appearance="outline" class="flex-1">
              <input
                matInput
                type="number"
                inputnumber="ENTIER"
                [(ngModel)]="actionnaire.actionnaire_NP"
                disabled="true"
              />
            </mat-form-field>
          </div>

          <div class="relative flex-1 flex items-center input-prefix">
            <div class="input-prefix-label important-title dark-txt">US</div>
            <mat-form-field appearance="outline" class="flex-1">
              <input
                matInput
                type="number"
                inputnumber="ENTIER"
                [(ngModel)]="actionnaire.actionnaire_US"
                disabled="true"
              />
            </mat-form-field>
          </div>

          <div class="relative flex-1 flex items-center input-prefix">
            <div class="input-prefix-label important-title dark-txt">Total</div>
            <mat-form-field appearance="outline" class="flex-1">
              <input
                matInput
                type="number"
                inputnumber="ENTIER"
                [value]="
                  (actionnaire.actionnaire_PP || 0) +
                  (actionnaire.actionnaire_NP || 0) +
                  (actionnaire.actionnaire_US || 0)
                "
                disabled="true"
              />
            </mat-form-field>
          </div>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="bg-[var(--main-card)] overflow-hidden">
    <custom-table
      [isLoading]="isLoading"
      [title]="'Mouvements d\'actions'"
      [columns]="columns"
      [data]="mouvements"
      [rowActions]="rowActions"
      [tableActions]="tableActions"
      [enableGlobalSearch]="false"
      [columnTemplates]="customTemplates"
    ></custom-table>
  </mat-card>
</div>

<ng-template #sensCell let-value>
  <span *ngIf="value == -1" class="badge badge-error">Sortie</span>
  <span *ngIf="value == 1" class="badge badge-success">Entrée</span>
</ng-template>

<ng-template #statutCell let-value>
  <span *ngIf="value == 0" class="badge badge-success">Effectué</span>
  <span *ngIf="value == 1" class="badge badge-warning">A faire</span>
  <span *ngIf="value == 2" class="badge badge-info">Futur</span>
</ng-template>
